import { axios, API_ROUTES } from "@/config";

export default {
  async save(data) {
    let result = await axios.post(`${API_ROUTES.setting.save}`, data);

    return result;
  },
};
